<template>
  <div id="disconnect">
    <div class="disconnect-wrapper">
      <div class="disconnect-container">
        <!--        <div id="select-all">-->
        <!--          <div class="form-container">-->
        <!--            <input type="checkbox" name="check-all" id="check-all" @click="selectAll">-->
        <!--            <label for="check-all">-->
        <!--              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="checked">-->
        <!--                <polyline points="9 11 12 14 22 4"></polyline>-->
        <!--                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>-->
        <!--              </svg>-->
        <!--              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="unchecked">-->
        <!--                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>-->
        <!--              </svg>-->
        <!--              <span>Select All</span>-->
        <!--            </label>-->
        <!--          </div>-->
        <!--        </div>-->

        <comp-message
          v-if="showMessage"
          :msgText="messageText"
          :msgSuccess="true"
          :msgError="false"
        />

        <comp-profile
          v-for="(item, index) in connectionList"
          :key="index"
          :profileName="item.name"
          :photoImage="item.partnerImage"
          :profileSub="item.type"
          :diconnectUser="true"
          :selectedId="item.connectionSeqId"
          @checkedParent="
            checkedvalue => {
              changeChecked(checkedvalue)
            }
          "
        />
      </div>

      <div class="button-group">
        <div class="button-container">
          <div
            class="button"
            @click="goPageWithParams('Connections', { listType: 'connected' })"
          >
            Cancel
          </div>
        </div>
        <div class="button-container">
          <div class="button" @click="disconnectUser">Disconnect</div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import CompMessage from '@/components/CompMessage'
import CompProfile from '@/components/CompProfile'
import ConnectionService from '@/services/connection-service'
import common from '@/utils/common'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'Disconnect',
  mixins: [common],
  props: ['value'],
  components: {
    CompProfile,
    CompMessage,
    CompLoading
  },
  data() {
    return {
      isLoading: false,

      showMessage: false,
      messageText: 'Message',
      connectionList: [],
      checkList: []
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('Disconnect')
    this.$parent.setBottomTab(false)
    this.getConnectionList('joined')
  },
  methods: {
    getConnectionList(type) {
      this.isLoading = true

      ConnectionService.getConnectionList(type).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.connectionList = resultData.connectionInfoList
          }
        }
      )
    },
    disconnectUser() {
      this.isLoading = true

      ConnectionService.disConnected(this.checkList).then(({ resultCode }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.getConnectionList('joined')
        }
      })
    },
    changeChecked(value) {
      if (this.checkList.includes(value)) {
        for (let i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i] === value) {
            this.checkList.splice(i, 1)
          }
        }
      } else {
        this.checkList.push(value)
      }
    },
    selectAll() {
      for (let i = 0; i < this.connectionList.length; i++) {
        this.changeChecked(this.connectionList[i].connectionSeqId)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/connections.scss" scoped></style>
